module.exports = __webpack_public_path__ + "6f52e3c3d406ede1a031d58b68631c1d.jpg";